import { useEffect, useState } from 'react';
import { getOrderCreatorEmailApi } from '../api';

export function useOrderCreatorEmail(orderId?: string, fromBackoffice?: boolean) {
  const [creatorEmail, setCreatorEmail] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (orderId && fromBackoffice) {
      getOrderCreatorEmailApi(orderId)
        .then(response => setCreatorEmail(response.data?.data?.email))
        .catch(() => {});
    } else {
      setCreatorEmail(undefined);
    }
  }, [orderId, fromBackoffice]);

  return creatorEmail;
}
